/**
 * SEO component that queries for data with
 * Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import React from "react"
import { useStaticQuery, graphql, withPrefix, Script } from "gatsby"

import { getCurrentLang } from "utils"

import en_links from "locales/en/links.json"
import pl_links from "locales/pl/links.json"

const links = {
  en: en_links,
  pl: pl_links,
}

function Seo({ title, description, children, image, pathname, noIndex }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            siteUrl
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const defaultTitle = site.siteMetadata?.title

  const lang = getCurrentLang(pathname)

  const getUrl = code => {
    if (pathname) {
      if (lang === code) {
        return `${site.siteMetadata.siteUrl}${pathname}`
      } else {
        const href = getHref(lang, code)

        if (href) {
          return `${site.siteMetadata.siteUrl}${href}`
        } else {
          return null
        }
      }
    } else {
      return null
    }
  }

  const getHref = (code, targetCode) => {
    if (!code || !targetCode) return "/"

    let hrefKey = null

    Object.entries(links[code]).forEach(([key, value]) => {
      if (value === pathname) {
        hrefKey = key
      }
    })

    return Object.entries(links[targetCode]).find(
      ([key, _]) => hrefKey === key
    )?.[1]
  }

  const url_en = getUrl("en")
  const url_pl = getUrl("pl")

  return (
    <>
      <title>{defaultTitle ? `${title} | ${defaultTitle}` : title}</title>
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content={site.siteMetadata?.author || ``} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={metaDescription} />
      <meta
        property="og:image"
        content={image ? image : withPrefix(`/og-image.png`)}
      />
      {url_en && (
        <>
          <link href={url_en} rel="alternate" hrefLang="x-default" />
          <link href={url_en} rel="alternate" hrefLang="en" />
          <link href={url_en} rel="alternate" hrefLang="en-gb" />
          <link href={url_en} rel="alternate" hrefLang="en-us" />
        </>
      )}
      {url_pl && (
        <>
          <link href={url_pl} rel="alternate" hrefLang="pl" />
          <link href={url_pl} rel="alternate" hrefLang="pl-pl" />
        </>
      )}
      {noIndex && <meta name="robots" content="noindex" />}
      <Script id="rewardful_1">{`(function(w,r){w._rwq=r;w[r]=w[r]||function(){(w[r].q=w[r].q||[]).push(arguments)}})(window,'rewardful');`}</Script>
      <Script
        id="rewardful_2"
        async
        src="https://r.wdfl.co/rw.js"
        data-rewardful="ad4435"
      />
      {children}
    </>
  )
}

export default Seo
